module.exports = __webpack_public_path__ + "img/table5.12b4c410.png";